import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=26dc379d&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26dc379d')) {
      api.createRecord('26dc379d', component.options)
    } else {
      api.reload('26dc379d', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=26dc379d&", function () {
      api.rerender('26dc379d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/sessions/detail.vue"
export default component.exports